// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__kDAqL","shadowRolling":"style_shadowRolling__jY0d4"};